export default {"src":"/login-app/[GIT_HASH]/_next/static/media/water.8b7bc80a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};